import { v4 as uuidv4 } from 'uuid';
export default () => {
  const uuid = uuidv4()
  return {
    $id: uuid,
    valueType: 'dateRange',
    FormItemProps: {
      label: '日期区间',
      name: uuid,
    },
  }
};
